import React from 'react';
import { Button, Tag } from '@decisiv/ui-components';

import AdminPage from 'lib/admin-kit/components/AdminPage';
import AdminPanel from 'lib/admin-kit/components/AdminPanel';

const ENDPOINT = '/internal_admin/admin_kit/ai_settings';

const formatUsd = (value) => (value == null ? '—' : `$${Number(value).toFixed(2)}`);

const Field = ({ label, children }) => (
  <div>
    <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4, color: '#555' }}>{label}</div>
    <div>{children}</div>
  </div>
);

const AiSettingsShow = ({ record }) => (
  <AdminPage
    title="AI Budget Settings"
    breadcrumbs={[{ text: 'AI Budget Settings' }]}
    actions={(
      <Button text="Edit" kind="secondary" onClick={() => { window.location.href = `${ENDPOINT}/edit`; }} />
    )}
  >
    <AdminPanel title="Details">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
        <Field label="Enforce AI budget limits">
          <Tag intent={record.enabled ? 'success' : 'neutral'} text={record.enabled ? 'Yes' : 'No'} />
        </Field>
        <Field label="Updated At">{record.updated_at ?? '—'}</Field>
        <Field label="Default warn threshold ($/day per dealer)">{formatUsd(record.default_daily_warn_usd)}</Field>
        <Field label="Default limit ($/day per dealer)">{formatUsd(record.default_daily_limit_usd)}</Field>
      </div>
    </AdminPanel>
  </AdminPage>
);

export default AiSettingsShow;
